import { render, staticRenderFns } from "./material_quality.vue?vue&type=template&id=cb626344&scoped=true"
import script from "./material_quality.vue?vue&type=script&lang=ts"
export * from "./material_quality.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb626344",
  null
  
)

export default component.exports